import { Box, Skeleton, Stack } from '@mui/material';


export const LoadingSkeleton = () => {

  return <Stack spacing={2}>
    <Skeleton variant="rectangular" width='100%' height={40} />
    <Skeleton variant="rectangular" width='100%' height={100} />
    <Skeleton variant="rectangular" width='100%' height={100} />
    <Box display='flex' justifyContent='space-between'>
      <Skeleton variant="text" width='48%' height={60} />
      <Skeleton variant="text" width='48%' height={60} />
    </Box>
  </Stack>
};
